import React from "react";
import { Link } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "componentsHomePage/Grid/GridContainer.js";
import GridItem from "componentsHomePage/Grid/GridItem.js";
import InfoArea from "componentsHomePage/InfoArea/InfoArea.js";
import { LocalBar, Home, LocalActivity } from '@material-ui/icons';

import styles from "../assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

const useStyles = makeStyles(styles);

export default function ProductSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>Our Services</h2>
          <hr className="text-info bg-info" />
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <Link to='/bars'>
              <InfoArea
                title="Bars and Clubs"
                description="The best bars, night clubs and themed parties in Albufeira. 
                Venue hire available for large groups."
                icon={LocalBar}
                iconColor="info"
                vertical
                />
            </Link>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <a href="https://www.airbnb.com/p/highclassproperties" target="_blank">
              <InfoArea
                title="Property Rentals"
                description="Several Apartments and Villas around Albufeira for rental."
                icon={Home}
                iconColor="info"
                vertical
                />
            </a>
              
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <a href="https://www.geticketsonline.com/events/" target="_blank">
              <InfoArea
                title="Event Tickets"
                description="Buy tickets online for all our events in Albufeira."
                icon={LocalActivity}
                iconColor="info"
                vertical
                />
            </a>
              
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
